<template>
	<div class="flex-column">
		<div class="full-height">
			<div>

				<label class="h6 display-block mt-10">
					작업일
					<input
						v-model="item.rDate"
						class="input-box radius-10 width-100 mt-10"
						type="date"
						/>
				</label>
				<label class="h6 display-block mt-10">
					작업내용
					<textarea
						v-model="item.report_content"
						class="input-box radius-10 width-100 mt-10"
						placeholder="작업내용 입력하세요"
						lang="ko">
					</textarea>
				</label>


				<label class="h6 display-block mt-10">
					현장 사진
				</label>
				<label class="display-block mt-10 input-box full-width radius-10">
					<v-icon
						class="color-icon"
					>mdi mdi-image</v-icon>
					{{ file_name }}
					<input
						v-show="false"
						type="file"
						placeholder="대표 이미지"
						class="input-box "
						maxlength="250"
						@change="setFile"
						accept="image/*"
						multiple
					/>
				</label>

				<label
					v-for="(file, f_index) in item.b_file"
					:key="'file_' + f_index"
					class="display-block mt-10 input-box full-width radius-10 justify-space-between"
				>
					<span><v-icon
						class="color-icon"
					>mdi mdi-image</v-icon>
					{{ file.name }}
						</span>

					<button
						@click="removeFile(f_index)"
					>
					<v-icon
						class="color-icon"
					>mdi mdi-close-box</v-icon>
					</button>
				</label>

			</div>
		</div>
		<div
			class="mt-auto"
		>
			<button
				class="btn-full btn-primary"
				@click="postReport"
			>등록</button>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ProjectReport'
	, props: ['user']
	, data: function(){
		return {
			program: {
				name: '작업일지 작성'
				, not_top: true
				, title: true
				, bottom: false
				, is_container: true
				, from: 'ProjectTaskView'
				, params: {
					idx: this.$route.params.idx
				}
			}
			, item: {
				task_uid: this.$route.params.idx
				, rDate: this.$date.getToday('-')
			}
		}
	}
	, computed: {

		file_name: function(){
			let name = '첨부파일'
			return name
		}
	}
	, methods: {
		postReport: async function(){
			if(this.item.b_file){

				for(let i = 0; i < this.item.b_file.length; i++ ){
					this.$set(this.item, 'b_file' + i, this.item.b_file[i])
				}
				this.$set(this.item, 'file_count', this.item.b_file.length)
			}

			this.$bus.$emit('on', true)

			try {
				const result = await this.$request.init({
					method: 'post'
					, url: 'project/postReport'
					, data: this.item
				})

				if(result.success){
					this.$bus.$emit('notify', { type: 'success', message: result.message})
					this.$bus.$emit('to', { name: 'ProjectTaskView', params: this.item.task_uid})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		,setFile: function(e){

			if(!this.item.b_file){
				this.$set(this.item, 'b_file', [])
			}
			if(this.item.b_file){
				for(let i = 0; i < e.target.files.length; i++){
					this.item.b_file.push(e.target.files[i])
				}
			}
		}
		, removeFile: function(f_index){
			this.item.b_file.splice(f_index, 1)
		}
	}
	, created() {
		this.$bus.$emit('onLoad', this.program)
	}
}
</script>